import IconArrowLeft from './icon/arrow-left.vue';
export default {
  components: {
    IconArrowLeft
  },
  props: {
    href: {
      type: String,
      required: true
    },
    newWindow: {
      type: Boolean,
      default: false
    }
  }
};